import { Alert, Box, Button, Checkbox, FormField, Header, Modal, RadioGroup, Select, SelectProps, SpaceBetween, Table } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useGlobalState } from '../../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../../layout';
const _preserve = React.version;
////import { useStoreAdmin } from '../../../context/useStoreAdmin';
//import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { mdiFileReplaceOutline, mdiPirate, mdiSwapHorizontal, mdiSwapHorizontalVariant, mdiTimerOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, getUser, setData, setLoading } from '../../../../../commons/functions';

import { addDays, format, parse } from 'date-fns';
import { es } from 'date-fns/locale/es';
import BadgeCustom from '../../../../../../components/extras/BadgeCustom';
import ConfirmDelete from '../../../../../../components/extras/ConfirmDelete';
import Favorites from '../../../../../../components/extras/Favorites';
import PopOverContact from '../../../../../../components/extras/PopOverContact';
import { fetchWithWatch } from '../../../../../../hooks/fetchWithWatch';
import { ItemDirector, ItemShift2 } from '../../../../../../resources/types';
const pageSize = 20;
type OptionDefinition = SelectProps.Option;

export const MembersEtcShiftsPage = () => {
    const { idUser, data, menu } = useGlobalState();
    const [myShifts, setMyShifts] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [viewPast, setViewPast] = useState(false);
    const [expanded, setExpanded] = useState<boolean[]>([true, false, false]);

    const [targetIdUser, setTargetIdUser] = useState(0);
    const [selectedTargetUser, setSelectedTargetUser] = useState<any>();
    const [targetShift, setTargetShift] = useState('');

    const [keyw, setKeyw] = useState<string>("");

    const [shifts, setShifts] = useState<ItemShift2[]>([]);
    const [flatShifts, setFlatShifts] = useState<any[]>([]);
    const [shiftExhange, setShiftExchage] = useState<any>();
    const [shiftReplace, setShiftReplace] = useState<any>();
    const [shiftSell, setShiftSell] = useState<any>();

    const [selectedTarget, setSelectedTarget] = useState<OptionDefinition | null>(null);
    const [usersTows, setUsersTows] = useState<ItemDirector[]>([]);


    const handleSellShift = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/mercenaries/shifts/sell',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    idShift: shiftSell.idShift,
                    start: format(addDays(new Date(), -1), 'dd-MM-yyyy'),
                    orderBy: "dateShift",
                    order: "asc",
                    jsonExchange: true
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data && data.shifts) {
                setShifts(pivotShifts(data.shifts))
                setFlatShifts(data.shifts);
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleRefresh = async () => {
        try {
            setShiftSell(undefined);
            setShiftExchage(undefined);
            setLoading(true);

            let body: any = {
                start: format(addDays(new Date(), -1), 'dd-MM-yyyy'),
                orderBy: "dateShift",
                order: "asc",
                jsonExchange: true
            }
            if (viewPast) {
                body.start = format(addDays(new Date(), -60), 'dd-MM-yyyy')
                body.end = format(addDays(new Date(), 0), 'dd-MM-yyyy')
            }

            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/shifts/list',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify(body)
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data && data.shifts) {
                ////console.log()
                setShifts(pivotShifts(data.shifts))
                setFlatShifts(data.shifts);
            }

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    const pivotShifts = (data: any[]): ItemShift2[] => {
        const grouped = data.reduce((acc: any, item: any) => {
            const date = item.dateShift;

            // Initialize the date group if it doesn't exist
            if (!acc[date]) {
                acc[date] = {
                    dateShift: date,
                    idShift: item.idShift,
                    isSelling: item.isSelling,
                    isToday: item.isToday,
                    isPast: item.isPast,
                    isFuture: item.isFuture,
                    AM: null,
                    PM: null,
                    DIR: null
                };
            }
            if (acc[date].hasOwnProperty(item.shift)) {
                acc[date][item.shift] = item;
            }

            return acc;
        }, {});
        return Object.values(grouped);
    };
    const filteredShifts: ItemShift2[] = shifts
        .filter((shift: any) => {
            if (myShifts) {
                return shift?.DIR?.idUser === idUser || shift?.PM?.idUser === idUser || shift?.AM?.idUser === idUser;
            }
            //
            return true;
        })
        .map((shift: any) => ({

            ...shift,
            label: `${shift.dateShift} - ${shift.userDirector}`,
            value: shift.idShift.toString(),
            keyw: shift.idShift.toString + " " + shift.dateShift + " " + shift.userDirector + " " + shift.userTow1 + " " + shift.userTow2 + " " + shift.userDirectorOld + " " + shift.userTow1Old + " " + shift.userTow2Old
        }));

    type ItemWarn = {
        reason: string;
        icon: React.ReactNode
    }
    const getUserWarning = (s: any): ItemWarn => {
        const defaultWarn: ItemWarn = { reason: "", icon: <></> };

        const target = flatShifts.filter((ts: any) => {

            //Items en que estoy registrado
            const hasExchange = ts.jsonExchange && Object.keys(ts.jsonExchange).length > 0;
            if (!hasExchange) return false

            const isSameShift = s.idShift === ts.idShift && s.shift === ts.shift
            if (isSameShift) return false

            if (ts.jsonExchange.target && ts.jsonExchange.target.idUser === idUser) {
                return true;
            }

            if (ts.jsonExchange.targets) {
                if (ts.jsonExchange.targets.some((t: any) => t.idUser === idUser && t.idShift === ts.idShift && t.shift === ts.shift)) {
                    return true;
                }
            }
            return false
        })
        const available = (!s.jsonExchange || Object.keys(s.jsonExchange).length === 0)
        if (!available) {
            ////console.log("shift", s)
        }
        const isMine = s.idUser === idUser;
        const sellings = flatShifts.filter((ts: any) => {
            //Items que estoy ofreciendo
            const hasExchange = ts.jsonExchange !== undefined && (!ts.jsonExchange || Object.keys(ts.jsonExchange).length === 0);
            if (!hasExchange) return false
            if (ts.idUser !== s.idUser) return false;
            return true
        })
        const isShiftSomewhereElse = flatShifts.filter((ts: any) => {
            if (ts.idShift === s.idShift) return false;
            if (ts.jsonExchange.targets !== undefined) {
                if (ts.jsonExchange.targets.some((ts2: any) =>
                    ts2.idUser === s.idUser && ts2.idShift === s.idShift && ts2.shift === s.shift
                )) return true;
            }
            if (ts.jsonExchange.target !== undefined) {
                if (ts.jsonExchange.target.idUser === s.idUser && ts.jsonExchange.target.idShift === s.idShift) return true;
            }
            return false
        })
        //return {reason: ` `, icon: <Box>{JSON.stringify(s)}</Box>};
        if (!isMine && s.isReplacementOpen === 1) {

            return {
                reason: ` `,
                icon: (
                    <BadgeCustom color="indigo">
                        <Icon path={mdiFileReplaceOutline} size={0.75} />
                        Reemplazo disponible
                    </BadgeCustom>)
            };

        }
        //return {reason: ` `, icon: <Box>{JSON.stringify(s)}</Box>};
        if (isMine && s.isReplacementOpen === 1) {

            return {
                reason: ` `,
                icon: (
                    <BadgeCustom color="indigo">
                        <Icon path={mdiFileReplaceOutline} size={0.75} />
                        Esperando reemplazo
                    </BadgeCustom>)
            };

        }
        if (!available && isMine && s.jsonExchange.type === "CLOSE") {
            //Esperando a usuario
            return {
                reason: ` `,
                icon: (<BadgeCustom color="lime">
                    <Icon path={mdiTimerOutline} size={0.75} /> {getUser(s.jsonExchange.target.idUser, data).displayName}...
                </BadgeCustom>
                )
            };

        } else if (!available && isMine && s.jsonExchange.type === "CLOSE") {
            //Esperando a usuario
            return {
                reason: ` `,
                icon: (<BadgeCustom color="lime">
                    <Icon path={mdiTimerOutline} size={0.75} /> {getUser(s.jsonExchange.target.idUser, data).displayName}...
                </BadgeCustom>
                )
            };
        } else if (!available && s.jsonExchange.type === "OPEN") { //isMine &&
            //Esperando a usuariossss
            return {
                reason: ` `,
                icon: (
                    <BadgeCustom color="purple">
                        <Icon path={mdiSwapHorizontalVariant} size={0.75} />
                        Enroque publicado
                    </BadgeCustom>)
            };
        } else if (available && isMine && isShiftSomewhereElse.length === 0 && s.isFuture === 1) {
            ////console.log("shift", s)
            ////console.log("targets", target)
            ////console.log("isShiftSomewhereElse", isShiftSomewhereElse)
            return {
                reason: ` `,
                icon: (
                    <BadgeCustom onClick={() => {
                        setModalOpen(true)
                        setShiftExchage(s)

                    }} color="blue">
                        <Icon path={mdiSwapHorizontalVariant} size={0.75} />
                        Enrocar
                    </BadgeCustom>)
            };


        }
        return defaultWarn;

    }

    const handleConfirmExchange = async () => {
        try {

            let body: any = {
                idShift: shiftExhange.idShift,
                approved: 0,
                type: exchangeOption,
                shift: shiftExhange.shift ?? "AM"
            }
            if (exchangeOption === "CLOSE") {
                body.target = {
                    idShift: selectedTarget,
                    idUser: targetIdUser,
                    shift: targetShift
                }
            }
            if (exchangeOption === "OPEN") {
                body.targets = []
            }
            //console.log(body)
            //return;
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/shifts/exchange',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify(body)
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data && data.shifts) {
                setShiftExchage(undefined)
                setExchangeOption("")
                setSelectedTargetUser(undefined)
                setShifts(pivotShifts(data.shifts))
                setFlatShifts(data.shifts);
            }

        } catch (error) {
            console.error('Error fetching users:', error);
            addNotification(``, "error", setData);
        } finally {
            setLoading(false);
        }
    };
    const handleConfirmReplace = async () => {
        try {
            let body: any = {
                idShift: shiftExhange.idShift,
                start: format(addDays(new Date(), -1), 'dd-MM-yyyy'),
                "orderBy": "dateShift",
                "order": "asc",
                "jsonExchange": true
            }
            //console.log(body)
            //return;
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/shifts/replace/add',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify(body)
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data && data.shifts) {
                setShiftExchage(undefined)
                setExchangeOption("")
                setSelectedTargetUser(undefined)
                setShifts(pivotShifts(data.shifts))
                setFlatShifts(data.shifts);
            }

        } catch (error) {
            console.error('Error fetching users:', error);
            addNotification(``, "error", setData);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        handleRefresh();
    }, []);


    useEffect(() => {
        /*
        if (!keyw.trim()) {
            setFilteredShifts(shifts);
        } else {
            const lowerKeyw = keyw.toLowerCase();
            setFilteredShifts(
                shifts.filter(s => s.keyw.toLowerCase().includes(lowerKeyw))
            );
        }
            */
    }, [keyw, shifts]);

    const [exchangeOption, setExchangeOption] = useState("");
    const exchangeOptions = [
        { value: "CLOSE", "label": "Cerrado (1:1)", "description": "Solicitar un intercambio de remolcador con un turno y remolcador particular" },
        { value: "OPEN", "label": "Abierto (1:N)", "description": "Turno puede ser intercambiado con cualquier remolcador/turno disponible" },
        { value: "REPLACE", "label": "Reemplazo (1:N)", "description": "Turno puede ser reemplazado por otro remolcador que desee cubrir su turno" },
    ]

    return (
        <CustomAppLayout
            toolsHide={true}
            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                < SpaceBetween size="xs" >
                    <Header

                        description={<Checkbox onChange={(e) => {
                            setMyShifts(e.detail.checked)
                        }} checked={myShifts}
                        >Mis turnos</Checkbox>}
                        actions={


                            <SpaceBetween direction="horizontal" size="xs">
                                <Favorites />
                            </SpaceBetween>
                        }>
                        Turnos { }

                    </Header>
                    <Table
                        stripedRows
                        stickyHeader
                        cellVerticalAlign='top'
                        variant='embedded'

                        columnDefinitions={[
                            {
                                id: "dateShift",
                                header: "Fecha",
                                width: 120,
                                cell: (item) => (
                                    <FormField
                                        label={item.dateShift}
                                    >
                                        {item?.DIR?.isSelling == 1 && <BadgeCustom color="lime" >En venta</BadgeCustom>}
                                        {item?.DIR?.isSelling == 2 && <BadgeCustom color="violet" >Vendido</BadgeCustom>}

                                        {
                                            item.DIR && item.DIR.idUser === idUser && item.DIR.isSelling === 0 ? (

                                                <BadgeCustom onClick={() => {
                                                    setShiftSell(item.DIR);

                                                }} size='small' color="yellow">Vender mi turno</BadgeCustom>

                                            ) : null
                                        }
                                    </FormField>
                                )
                            },
                            {
                                id: "dayShift",
                                header: "Día",
                                width: 70,
                                cell: (item) => {
                                    const day = format(parse(item.dateShift, "dd-MM-yyyy", new Date()), "EEEE", { locale: es });
                                    return day.charAt(0).toUpperCase() + day.slice(1, 3);
                                }
                            },
                            {
                                id: "userDirector",
                                header: "Director",
                                cell: (item) =>
                                    item.DIR && (
                                        <FormField
                                            description={
                                                <>

                                                    {item.DIR.userOld !== "" ? <>
                                                        <Icon path={mdiSwapHorizontal} size={1} /> {item.DIR.userOld}
                                                    </> : ""}

                                                    {item.DIR.idUserMercenary !== 0 ? <>
                                                        <Icon path={mdiSwapHorizontal} size={1} /> {item.DIR.user}
                                                    </> : ""}
                                                </>

                                            }
                                            label={
                                                <SpaceBetween direction="horizontal" size="xs">
                                                    {item.DIR.idUserMercenary !== 0 && (<Icon path={mdiPirate} size={0.75} />)}
                                                    {item.DIR.idUserMercenary !== 0 ?
                                                        item.DIR.isToday ?
                                                            <PopOverContact idUser={item.DIR.idUserMercenary} />
                                                            :
                                                            item.DIR.userMercenary
                                                        :
                                                        item.DIR.isToday ?
                                                            <PopOverContact idUser={item.DIR.idUser} />
                                                            :
                                                            item.DIR.user
                                                    }
                                                </SpaceBetween>

                                            }
                                        >

                                        </FormField>
                                    )


                                //sortingField: "displayName",
                            },
                            {
                                id: "userTow1",
                                header: "Remolcador AM",
                                cell: (item: ItemShift2) => {
                                    if (!item.AM) return null;

                                    const warn = getUserWarning(
                                        item.AM
                                    );
                                    return (
                                        <FormField
                                            description={
                                                item.AM.userOld != ""
                                                    ? <>
                                                        <Icon path={mdiSwapHorizontal} size={1} /> {item.AM.userOld}
                                                    </>
                                                    : null
                                            }
                                            label={
                                                <>
                                                    {item.isToday ?
                                                        <PopOverContact idUser={item.AM.idUser} /> : item.AM.user}

                                                </>
                                            }
                                            constraintText={warn.reason ? <>{warn.icon} {warn.reason}</> : undefined}
                                        >
                                        </FormField>
                                    )
                                }
                            },
                            {
                                id: "userTow2",
                                header: "Remolcador PM",
                                cell: (item: ItemShift2) => {
                                    if (!item.PM) return null;

                                    const warn = getUserWarning(item.PM);
                                    return (
                                        <FormField
                                            description={
                                                item.PM.userOld != ""
                                                    ? <>
                                                        <Icon path={mdiSwapHorizontal} size={1} /> {item.PM.userOld}
                                                    </>
                                                    : null
                                            }

                                            label={
                                                <span>
                                                    {item.isToday ? <PopOverContact idUser={item.PM.idUser} /> : item.PM.user}
                                                </span>
                                            }
                                            constraintText={warn.reason ? <>{warn.icon} {warn.reason}</> : undefined}
                                        />
                                    )
                                }
                            }]}
                        //items={filteredShifts}
                        items={filteredShifts}
                        selectionType={undefined}
                        trackBy="idShift"
                    />
                    {shiftExhange && (
                        <Modal header={<Header
                            description={
                                `Intercambiar mi turno del ${shiftExhange.dateShift} ${shiftExhange.idUser === idUser ? "AM" : "PM"} (#${shiftExhange.idShift})`
                            }
                        >Solicitud de intercambio/reemplazo</Header>}


                            visible={shiftExhange !== undefined} onDismiss={() => {
                                setShiftExchage(undefined)
                                setExchangeOption("")
                                setSelectedTargetUser(undefined)
                            }}

                            footer={
                                <Box>
                                    <Box float='left'>
                                        <Button variant="link" onClick={() => {
                                            setShiftExchage(undefined)
                                            setExchangeOption("")
                                            setSelectedTargetUser(undefined)
                                        }}>Cancelar</Button>
                                    </Box>
                                    <Box float='right'>
                                        <Button variant="primary"
                                            disabled={exchangeOption === "" || (exchangeOption === "CLOSE" && targetIdUser === 0)}
                                            onClick={() => {
                                                if (exchangeOption === "REPLACE")
                                                    handleConfirmReplace();
                                                else
                                                    handleConfirmExchange();

                                            }}>Enviar solicitud</Button>
                                    </Box>
                                </Box>
                            }>
                            <SpaceBetween size="s">
                                <RadioGroup
                                    items={exchangeOptions}
                                    value={exchangeOption}
                                    onChange={({ detail }) => {
                                        setExchangeOption(detail.value)

                                        setTargetIdUser(0);
                                        setTargetShift(undefined);
                                        setSelectedTarget(undefined)
                                        setSelectedTargetUser(undefined)

                                    }} // Just store the string
                                />
                                {exchangeOption === "CLOSE" && (
                                    <SpaceBetween size="s">
                                        <Alert type="info" header="Info">
                                            Usted puede optar a solicitar el intercambio de <strong>su turno</strong>. Debe haber coordinado previamente con el otro miembro para realizar el intercambio. Una vez enviada la solicitud, el otro usuario deberá <strong>aprobarla</strong> para que el intercambio se haga efectivo. Al momento de efectuarse la aprobación ambos recibiran un correo de <strong>confirmación</strong>.
                                        </Alert>
                                        <FormField label="Turno a solicitar intercambio">
                                            <Select
                                                filteringType="auto"
                                                expandToViewport
                                                selectedOption={selectedTargetUser ?? null}
                                                onChange={({ detail }) => {
                                                    {
                                                        var dt: any = detail.selectedOption;
                                                        setTargetIdUser(Number(dt?.idUser));
                                                        setTargetShift(dt?.shift);
                                                        setSelectedTarget(dt.idShift)
                                                        setSelectedTargetUser(detail.selectedOption)
                                                    }
                                                }}
                                                options={flatShifts
                                                    .filter((tow: any) => {

                                                        if (tow.idUser === idUser || tow.shift === "DIR" || (tow.jsonExchange && Object.keys(tow.jsonExchange).length > 0) || tow.isFuture === 0) return false;

                                                        //if (tow.idUser !== idUser && tow.jsonExchange.approved === undefined) return false;

                                                        const isAlreadyInvolved = flatShifts.some((ts: any) => {
                                                            const ex = ts.jsonExchange;
                                                            if (!ex || Object.keys(ex).length === 0) return false;
                                                            const isTargetClose = ex.target?.idShift === tow.idShift && ex.target?.shift === tow.shift;
                                                            const isTargetOpen = Array.isArray(ex.targets) &&
                                                                ex.targets.some((t: any) => t.idShift === tow.idShift && t.shift === tow.shift);
                                                            return isTargetClose || isTargetOpen;
                                                        });
                                                        return !isAlreadyInvolved;
                                                    })
                                                    .map((s: any) => {
                                                        return {
                                                            value: s.idShift.toString(),
                                                            label: `${s.dateShift}-${s.shift} - ${s.user}`,
                                                            idUser: s.idUser,
                                                            shift: s.shift,
                                                            idShift: s.idShift,
                                                        }
                                                    })
                                                }
                                            />
                                        </FormField>
                                    </SpaceBetween>
                                )}
                                {exchangeOption === "OPEN" && (
                                    <SpaceBetween size="s">
                                        <Alert type="info" header="Info">
                                            Usted puede optar a solicitar el intercambio de <strong>su turno</strong>. Su turno será publicado a el grupo remolcadores para que uno o más remolcadores se puedan inscribir en el enroque. Cuando usted estime conveniente y exista a lo menos un postulante, podra seleccionar el turno que le sea más conveniente.
                                        </Alert>
                                    </SpaceBetween>
                                )}
                                {exchangeOption === "REPLACE" && (
                                    <SpaceBetween size="s">
                                        <Alert type="info" header="Info">
                                            <strong>Su turno</strong> queda disponible para que otro remocaldor cubra su posición. Este turno será publicado en el grupo de remolcadores. Una vez adjudicado el reemplazo, usted recibirá una confirmación y su turno de remolcador será actualizado en el sistema y la reserva de remolcador de turno será reprogramada
                                        </Alert>
                                    </SpaceBetween>
                                )}
                            </SpaceBetween>
                        </Modal >
                    )}
                    <ConfirmDelete

                        subtitle={`El pago por la venta del turno hacia el socio que se lo adjudique es de 4 UF, las cuales serán descontadas desde su cuenta club. El turno solo puede ser puesto a la venta hasta el ${shiftSell?.dateShift} a las 23:00 hrs.`}
                        header={`Vender turno ${shiftSell?.dateShift} - ${shiftSell?.user}`} show={shiftSell !== undefined}
                        onDismiss={() => setShiftSell(undefined)}
                        onConfirm={async () => {
                            handleSellShift()
                        }} confirmWord={'acepto'} action={'Poner a la venta'} warning={'Una vez que su turno ha sido puesto en venta, este no puede ser cancelado ni retractado.'}

                    />
                </SpaceBetween >
            }
        />

    );
};
